import { render, staticRenderFns } from "./VClubCard.vue?vue&type=template&id=e9bf6978&scoped=true&"
import script from "./VClubCard.vue?vue&type=script&lang=js&"
export * from "./VClubCard.vue?vue&type=script&lang=js&"
import style0 from "./VClubCard.vue?vue&type=style&index=0&id=e9bf6978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bf6978",
  null
  
)

export default component.exports